import { PersistentAppKind } from 'src/orchd-client';

/**
 * Mapping of PersistentAppKind to example startup commands.
 * Used to pre-populate the startup command field when the runtime kind changes.
 */
export const runtimeStartCommandMapping: Record<PersistentAppKind, string> = {
  [PersistentAppKind.generic]: 'npm start',
  [PersistentAppKind.nodejs]: 'npm start',
  [PersistentAppKind.tomcat]: 'catalina.sh run',
  [PersistentAppKind.laravel]: 'php artisan queue:work',
  [PersistentAppKind.php]: 'php -S 0.0.0.0:8000 -t public',
  [PersistentAppKind.openclaw]: 'openclaw-worker start',
  [PersistentAppKind.n8n]: 'n8n-worker start',
  [PersistentAppKind.django]: 'python manage.py runserver 0.0.0.0:8000',
};

/**
 * Returns a suggested startup command for the given runtime kind.
 * @param kind The runtime kind
 * @returns A suggested startup command, or empty string if kind is undefined
 */
export function getStartupCommandForRuntime(kind: PersistentAppKind | undefined): string {
  if (!kind) return '';
  return runtimeStartCommandMapping[kind] || '';
}
